// extracted by mini-css-extract-plugin
module.exports = {"list":"HeadErrors__list--1-x6j","item":"HeadErrors__item--2Gr3E"};